import React from 'react';
import { Button } from 'antd-mobile';
import wx from 'weixin-js-sdk';
import './index.scss';

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1,
        };
    }(),
};

/**
 * 充值结果页：微信 H5 支付回调可能落在系统浏览器。
 * 无充值页专用 scheme 时，默认唤起 App 首页即可。
 * 与线上 successPage 隔离。
 */
function WalletSuccessPage() {
    let search = window.location.search.slice(1);
    let params = search.split('&');
    var theRequest = new Object();
    for (let i = 0; i < params.length; i++) {
        if (!params[i]) continue;
        theRequest[params[i].split('=')[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
    }
    const isFail = ['0', 'fail', 'false', '2'].includes(String(theRequest.status || theRequest.payStatus || '').toLowerCase());
    document.title = ""
    const emptyIcon = require('../../assets/wancheng.png');

    const tryNativeGoBack = () => {
        const ua = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(ua);
        try {
            if ((browser.versions.android || OpenHarmony) && window.android) {
                // 取消/失败必须 Exit，否则 App 仍可能停留在「充值成功」
                if (isFail && typeof window.android.onCampusPayExit === 'function') {
                    window.android.onCampusPayExit();
                    return true;
                }
                if (typeof window.android.onCampusPayGoBack === 'function') {
                    window.android.onCampusPayGoBack();
                    return true;
                }
                // GoBack 不可用时走 Exit
                if (typeof window.android.onCampusPayExit === 'function') {
                    window.android.onCampusPayExit();
                    return true;
                }
                if (typeof window.showToast === 'function') {
                    window.showToast();
                    return true;
                }
            }
            const handlers = window.webkit && window.webkit.messageHandlers;
            if (browser.versions.ios && handlers) {
                if (handlers.onCampusPayGoBack) {
                    handlers.onCampusPayGoBack.postMessage('');
                    return true;
                }
                if (handlers.onCampusPayExit) {
                    handlers.onCampusPayExit.postMessage('');
                    return true;
                }
            }
        } catch (e) { /* 系统浏览器无桥 */ }
        return false;
    };

    // 系统浏览器：无路径，等同点桌面图标进首页（Android 靠包名 MAIN+LAUNCHER，iOS 靠裸 scheme）
    const openAppHome = () => {
        const custom = theRequest.returnScheme || theRequest.scheme || theRequest.appUrl;
        if (custom) {
            window.location.href = custom;
            return;
        }
        const ua = navigator.userAgent;
        if (/android/i.test(ua)) {
            window.location.href =
                'intent://#Intent;action=android.intent.action.MAIN;category=android.intent.category.LAUNCHER;package=com.klcxkj.zqxy;end';
            return;
        }
        // iOS：无路径，趣智 scheme 只拉起 App 进首页
        window.location.href = 'QSchool://';
    };

    const closePage = () => {
        const ua = navigator.userAgent;
        const uaLower = ua.toLowerCase();

        if (tryNativeGoBack()) return;

        if (uaLower.match(/MicroMessenger/i) == 'micromessenger') {
            try {
                wx.miniProgram.getEnv((res) => {
                    if (res && res.miniprogram) {
                        wx.miniProgram.navigateBack({ delta: 1 });
                        return;
                    }
                    openAppHome();
                });
            } catch (e) {
                openAppHome();
            }
            return;
        }

        if (/Alipay/i.test(ua)) {
            try {
                if (window.my && typeof window.my.navigateBack === 'function') {
                    window.my.navigateBack();
                    return;
                }
            } catch (e) { /* ignore */ }
            openAppHome();
            return;
        }

        openAppHome();
    };

    return (
        <div className="wallet-success-page">
            <div className="wallet-success-page-content">
                <img className="emptyIcon" src={emptyIcon} alt="" />
                {/* <div className="title">{isFail ? '充值未完成' : '充值成功'}</div> */}
                <Button block color="primary" size="large" onClick={closePage}>
                    返回钱包
                </Button>
            </div>
        </div>
    );
}

export default WalletSuccessPage;
